import { _ } from "libs";

import React from "react";
import { SearchResult } from "../types";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import ClubItemLarge from "./items/club/large";

const otherClubsComparator = function(a: SearchResult, b: SearchResult): number {
	if (a.contractedClub === true && b.contractedClub === true) {
		return 0;
	} else if (a.contractedClub === true) {
		return -1;
	} else if (b.contractedClub === true) {
		return 1;
	} else {
		return 0;
	}
};

const clubAvailableComparator = function(a: SearchResult, b: SearchResult): number {
	if (a.availableSlots.length > 0 && b.availableSlots.length > 0) {
		if (!a.nearestSlot) return 1;

		if (!b.nearestSlot) return -1;

		if (a.nearestSlot.startDateTime === a.searchTimeStamp && b.nearestSlot.startDateTime === b.searchTimeStamp) {
			return 0;
		} else if (a.nearestSlot.startDateTime === a.searchTimeStamp) {
			return -1;
		} else if (b.nearestSlot.startDateTime === b.searchTimeStamp) {
			return 1;
		} else {
			return a.nearestSlot.startDateTime - b.nearestSlot.startDateTime;
		}
	} else if (a.availableSlots.length > 0) {
		return -1;
	} else if (b.availableSlots.length > 0) {
		return 1;
	} else {
		if (a.type != null && a.type === "private" && b.type != null && b.type === "private") {
			return 0;
		} else if (a.type != null && a.type === "private") {
			return -1;
		} else if (b.type != null && b.type === "private") {
			return 1;
		} else {
			return 0;
		}
	}
};

const clubFavoriteComparator = function(a: SearchResult, b: SearchResult): number {
	if (a.favorite && b.favorite) {
		return 0;
	} else if (a.favorite === true) {
		return -1;
	} else if (b.favorite === true) {
		return 1;
	} else {
		return 0;
	}
};

const compare = function(a: SearchResult, b: SearchResult): number {
	for (let comparator in chainedComparator) {
		const result = chainedComparator[comparator](a, b);
		if (result !== 0) {
			return result;
		}
	}
	return 0;
};

const chainedComparator = [otherClubsComparator, clubAvailableComparator, clubFavoriteComparator];

const CourtResult = ({ result, index, timestamp }: { result: SearchResult; index: number; timestamp: number }) => {
	let selectedTime = timestamp;
	let availability = <div className="noSlots">{_("courts.results.availability.noSlots")}</div>;

	if (result.nearestSlot) {
		const slot = result.nearestSlot;
		const time = moment.unix(slot.startDateTime).tz(result.timeZone);
		selectedTime = time.unix();
		availability = (
			<div key={slot.startDateTime} className={result.className}>
				{_("courts.results.availability", slot.numberOfCourts, {
					numberOfCourts: slot.numberOfCourts,
					time: time.format("HH:mm"),
				})}
			</div>
		);
	} else {
		if (result.type === "private") {
			availability = <div className="private">{_("courts.results.availability.private")}</div>;
		} else if (result.contractedClub === false) {
			availability = <div className="notContracted">{_("courts.results.availability.notContracted")}</div>;
		}
	}

	return (
		<Link
			to={{
				pathname: `/club/${result.clubId}`,
				state: { timestamp: selectedTime },
				search: `?timestamp=${selectedTime}`,
			}}
			className="cell"
			target="_blank"
		>
			<ClubItemLarge
				name={index + 1 + ". " + result.clubName}
				meta={result.address1}
				photoUrl={result.photoUrl}
				availability={availability}
			/>
		</Link>
	);
};

const CourtResults = ({ results = [], timestamp }: { results: SearchResult[]; timestamp: number }) => {
	if (results.length === 0) {
		return <div className="noResults">{_("courts.noResults")}</div>;
	}

	results = results.sort(compare);
	return (
		<div className="table searchResults">
			{results.map((result, index) => {
				return <CourtResult key={result.clubId} result={result} index={index} timestamp={timestamp} />;
			})}
		</div>
	);
};

export default CourtResults;
